module.exports = __webpack_public_path__ + "static/media/sink-state-2.c0574b45.wav";